import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import { useState, useEffect } from 'react';
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import taskApi from './../../api/tasks';
import LineHandover from "./LineHandover";
import { IssueHistory } from '../../components/Handover';
import FlightScheduleView from "./FlightSchedule";
import { useQueryTab } from '../../utils/usePersistedTab';
import WorkPackageCalendar from './WorkPackageCalendar';

const Line = () => {
  const store = useSelector((state: RootState) => state);
  const groups = store.user.me.user_clearence_groups;
  const isAdmin = groups.includes("Line Planner") || groups.includes("Line Supervisor Edit");
  const [loading, setLoading] = useState<boolean>(true);
  const [allTails, setAllTails] = useState<Array<string>>([]);
  const isLineSupervisorAdmin = groups.includes("Line Supervisor Edit");
  const { tabValue, setTabValue } = useQueryTab("tab", 0);

  useEffect(() => {
    setLoading(true);
    taskApi.GetAllTailNumbers().then(res => {
      setAllTails(res.data);
    });
  }, []);

  return (
    <div>
      {loading && <LinearProgress />}
      <Tabs
        tabNames={["Calendar", "Flight schedule", "Supervisor Handover", "Issue History"]}
        onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
        tabValue={tabValue}
      />
      {tabValue === 0 && <WorkPackageCalendar setLoading={setLoading} isAdmin={isAdmin} accessGroups={groups} location="KEF" />}
      {tabValue === 1 && < FlightScheduleView isLineSupervisorAdmin={isLineSupervisorAdmin} setLoading={setLoading}/> }
      {tabValue === 2 && < LineHandover setLoading={setLoading} allTails={allTails} isLineSupervisorAdmin={isLineSupervisorAdmin} />}
      {tabValue === 3 && <IssueHistory setLoading={setLoading} />}
    </div>
  )
}

export default Line;